import type { Filter, FiltersByOutcomeParameterMap } from '../types';

export const getNumericFilter = (
    filtersMap: FiltersByOutcomeParameterMap,
): Filter | undefined => {
    for (const [, filter] of filtersMap) {
        if (filter.kind === 'NUMERIC_PARAM_VALUE') {
            return filter;
        }
    }
    return undefined;
}
